module.exports = __webpack_public_path__ + "img/img_case_index_01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/case/img_case_index_01.jpg
// module id = 781
// module chunks = 0